import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2, MapPin, Globe, X } from 'lucide-react';
import api from '../../services/api';
import { toast } from 'react-toastify';
import styles from './SettingsPage.module.css';
import commonStyles from '../../styles/common.module.css';

const CityList = () => {
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({ name: '', region: '' });
  const [editingId, setEditingId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCities = async () => {
    try {
      setLoading(true);
      const response = await api.get('/settings/cities/');
      setCities(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки городов');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/settings/cities/${editingId}/`, formData);
        toast.success('Город обновлён');
      } else {
        await api.post('/settings/cities/', formData);
        toast.success('Город создан');
      }
      closeModal();
      fetchCities();
    } catch (error) {
      toast.error('Ошибка сохранения города');
    }
  };

  const handleEdit = (city) => {
    setFormData({ name: city.name, region: city.region });
    setEditingId(city.id);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Удалить город?')) {
      try {
        await api.delete(`/settings/cities/${id}/`);
        toast.success('Город удалён');
        fetchCities();
      } catch (error) {
        toast.error('Ошибка удаления города');
      }
    }
  };

  const openAddModal = () => {
    setFormData({ name: '', region: '' });
    setEditingId(null);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({ name: '', region: '' });
    setEditingId(null);
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingContent}>
          <div className={styles.spinner}></div>
          <p className={styles.loadingText}>Загрузка городов...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.sectionHeader}>
        <h3>
          <MapPin size={24} style={{ marginRight: '0.5rem', color: '#0f766e' }} />
          Города
        </h3>
        <button className={styles.addButton} onClick={openAddModal}>
          <Plus size={18} />
          Добавить город
        </button>
      </div>

      <div className={styles.tableWrapper}>
        {cities.length === 0 ? (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <MapPin size={48} />
            </div>
            <h3>Нет городов</h3>
            <p>Добавьте первый город для начала работы</p>
          </div>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Название</th>
                <th>Регион</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {cities.map(city => (
                <tr key={city.id} className={styles.clickableRow} onClick={() => handleEdit(city)}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <MapPin size={16} style={{ color: '#0f766e' }} />
                      <strong>{city.name}</strong>
                    </div>
                  </td>
                  <td>{city.region || '—'}</td>
                  <td>
                    <button
                      className={styles.actionButton}
                      onClick={(event) => { event.stopPropagation(); handleDelete(city.id); }}
                      title="Удалить"
                    >
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>
                <MapPin size={20} />
                {editingId ? 'Редактировать город' : 'Добавить город'}
              </h3>
              <button className={styles.modalCloseButton} onClick={closeModal}>
                <X size={20} />
              </button>
            </div>
            <div className={styles.modalBody}>
              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.formGroup}>
                  <label>
                    <MapPin size={16} />
                    Название города
                  </label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="Введите название города"
                    required
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>
                    <Globe size={16} />
                    Регион
                  </label>
                  <input
                    type="text"
                    value={formData.region}
                    onChange={(e) => setFormData({ ...formData, region: e.target.value })}
                    placeholder="Введите название региона"
                  />
                </div>
                <button type="submit" className={styles.submitButton}>
                  {editingId ? 'Обновить город' : 'Создать город'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CityList;
